const routes = {
	home: "/",
	login: "/login",
	invoices: "/invoices",
	seller: "/sellers",
	tag: "/tag",
	profile: "/profile",
	show: "/show",
	search: "/search",
};

export default routes;
